import { useNavigate } from "react-router-dom";
import type { Product } from "../../../../types/product";

interface Props {
  currentId: string;
  category: string;
  allProducts: Product[];
}

export default function RelatedProducts({ currentId, category, allProducts }: Props) {
  const navigate = useNavigate();
  const related = allProducts
    .filter((p) => p.id !== currentId && p.category === category)
    .slice(0, 4);

  if (related.length === 0) return null;

  return (
    <section className="mt-16 pt-12 border-t border-gray-100">
      <h2 className="text-xl font-extrabold text-gray-900 mb-6">You May Also Like</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {related.map((p) => {
          const saveDollars = p.originalPrice ? p.originalPrice - p.price : null;
          return (
            <div
              key={p.id}
              className="bg-white border border-gray-100 rounded-xl overflow-hidden hover:border-amber-300 transition-colors cursor-pointer group"
              onClick={() => { navigate(`/shop/${p.id}`); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            >
              <div className="relative w-full bg-gray-50 overflow-hidden" style={{ aspectRatio: "1 / 1" }}>
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300"
                />
                {saveDollars && p.inStock && (
                  <span className="absolute top-2 left-2 bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded">
                    Save ${saveDollars.toLocaleString()}
                  </span>
                )}
                {!p.inStock && (
                  <span className="absolute top-2 left-2 bg-gray-600 text-white text-[10px] font-bold px-2 py-0.5 rounded">
                    Sold Out
                  </span>
                )}
              </div>
              <div className="p-3">
                <p className="text-[10px] text-gray-400 uppercase tracking-wider mb-0.5 font-semibold">{p.brand}</p>
                <h4 className="text-xs font-semibold text-gray-900 leading-snug line-clamp-2 mb-2">{p.name}</h4>
                <div className="flex items-baseline gap-1.5">
                  <span className={`font-extrabold text-sm ${p.originalPrice ? "text-red-600" : "text-gray-900"}`}>
                    ${p.price.toLocaleString()}
                  </span>
                  {p.originalPrice && (
                    <span className="text-xs text-gray-400 line-through">${p.originalPrice.toLocaleString()}</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
